export default __webpack_public_path__ + "static/media/logo.a88331cb.svg";